<template>
  <section class="h_04">
    <m-img
      class="h_04_title"
      src="@/v2/mobile/assets/image/h_04_title.svg"
    ></m-img>
    <m-video
      ref="video1"
      class="video_size"
      autoplay
      muted
      loop
      disablepictureinpicture
      x5-playsinline
      playsinline
      webkit-playsinline="true"
      poster="@/v2/mobile/assets/video/poster/v_04.webp"
      src="@/v2/mobile/assets/video/v_4.mp4"
    />
    <div class="video_gradient"></div>
  </section>
</template>
<script>
import { videoPlayByVisibleAreaH5 } from '@/utils'

export default {
  data() {
    return {
      preload_: true,
    }
  },
  mounted() {
    const video1 = this.$refs.video1
    video1 && videoPlayByVisibleAreaH5(video1)
  },
}
</script>

<style lang="less" scoped>
.h_04 {
  position: relative;
}
.video_size {
  width: 100%;
  height: 100%;
}
.h_04_title {
  position: absolute;
  margin: 0 24px;
  top: 14%;
  width: 85%;
}
.video_gradient {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 40px;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.9) 100%
  );
}
</style>
